import React, { Component } from "react";
import { Nav } from "react-bootstrap";
import styled, { keyframes } from "styled-components";
import { Link } from "react-router-dom";
import { zoomIn } from "react-animations";
import ReactRoundedImage from "react-rounded-image";
import ProfessionalIcon from "../../multi-page-attributes/images/professional-icon.PNG";
import Typing from "react-typing-animation";
import PageFooter from "../../multi-page-attributes/PageFooter";
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import GitHubIcon from '@material-ui/icons/GitHub';
import EmailIcon from '@material-ui/icons/Email';
import ResumeIcon from '@material-ui/icons/Description';
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Resume from "../../multi-page-attributes/resume.pdf";

const ZoomIn = styled.div`animation: 1.5s ${keyframes`${zoomIn}`}`;

export default class NameComponentRegular extends Component {
    render() {
        return (
            <div>
                <div style={{
                    marginTop: '20%',
                    display: "flex",
                    justifyContent: "center",
                    flexWrap: "wrap",
                }}>
                    <ZoomIn>
                        <ReactRoundedImage
                            image={ProfessionalIcon}
                            roundedColor="#FFFFFF"
                            imageWidth="250"
                            imageHeight="250"
                            roundedSize="10"
                        />
                    </ZoomIn>
                    <div style={{
                        paddingTop: 30,
                        paddingLeft: 30,
                        paddingRight: 30,
                        color: "#000000",
                        textAlign: "center",
                    }}>
                        <h1 style={{ paddingBottom: 10 }}><b>Hi, I'm <span style={{ color: "#007BFF" }}>
                            Aniket.</span></b></h1>
                        <Typing loop={true} speed={60}>
                            Software Engineer.
                            <Typing.Delay ms={1000} />
                            <Typing.Backspace count={20} />
                            Competitive Programmer.
                            <Typing.Delay ms={1000} />
                            <Typing.Backspace count={30} />
                            Car Enthusiast.
                            <Typing.Delay ms={1000} />
                            <Typing.Backspace count={20} />
                            Skater.
                            <Typing.Delay ms={1000} />
                            <Typing.Backspace count={10} />
                            Tinkerer.
                            <Typing.Delay ms={1000} />
                            <Typing.Backspace count={20} />
                        </Typing>
                        <div style={{ paddingTop: 18, display: "flex",  justifyContent: "center" }}>
                            <Nav.Link href={Resume} target="_blank">
                                <ResumeIcon style={{ height: 30, width: 30 }} />
                            </Nav.Link>
                            <Nav.Link href={"https://www.linkedin.com/in/aniket-agnihotri"}
                                      target={"_blank"}>
                                <LinkedInIcon style={{ height: 30, width: 30 }} />
                            </Nav.Link>
                            <Nav.Link href={"https://github.com/aniketagnihotri"}
                                      target={"_blank"}>
                                <GitHubIcon style={{ height: 30, width: 30 }} />
                            </Nav.Link>
                            <Nav.Link href="mailto:aagnihot@purdue.edu">
                                <EmailIcon style={{ height: 30, width: 30 }} />
                            </Nav.Link>
                        </div>
                    </div>
                    <div style={{
                        marginTop: "40%",
                        padding: "2%"
                    }}>
                        <div style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            flexWrap: "wrap",
                            padding: "3%"
                        }}>
                            <Link to={{ pathname: '/select'}} style={{ color: "#007BFF",  backgroundColor: "#FFFFFF", // "#0F3057"
                                borderRadius: 10,  }}>
                                <ExpandMoreIcon style={{ height: 50, width: 50 }} />
                            </Link>
                        </div>
                        <PageFooter />
                    </div>
                </div>
            </div>
        );
    }
}
